'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactUtils = require('react-utils');

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _UITextInput = require('../input/UITextInput');

var _UITextInput2 = _interopRequireDefault(_UITextInput);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _IMESafe = require('../decorators/IMESafe');

var _IMESafe2 = _interopRequireDefault(_IMESafe);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _MeasureText = require('../utils/MeasureText');

var _decorators = require('../utils/propTypes/decorators');

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getMinimumSearchMessage = function getMinimumSearchMessage(minimumSearchCount, value) {
  var valueLength = value ? value.length : 0;
  var charsNeeded = minimumSearchCount - valueLength;
  if (valueLength && charsNeeded > 0) {
    return _I18n2.default.text('salesUI.UISearchInput.minimumSearchMessage', {
      count: charsNeeded
    });
  }
  return null;
};

var UISearchInput = _react2.default.createClass({
  displayName: 'UISearchInput',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, _UITextInput2.default.propTypes, {
    clearable: _react.PropTypes.bool.isRequired,
    fieldsetContext: _FieldsetContext.propType,
    icon: _react.PropTypes.bool.isRequired,
    minimumSearchCount: _react.PropTypes.number.isRequired,
    size: _react.PropTypes.oneOf(['default', 'extra-large']).isRequired,
    type: (0, _decorators.hidden)(_UITextInput2.default.propTypes.type)
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UITextInput2.default.defaultProps, {
      clearable: true,
      fieldsetContext: {},
      icon: true,
      minimumSearchCount: 0,
      placeholder: function placeholder() {
        return _I18n2.default.text('salesUI.UISearchInput.placeholder');
      },
      size: 'default',
      type: 'search',
      value: ''
    });
  },
  getInitialState: function getInitialState() {
    return {
      minimumSearchMessageOverflows: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.computeMinimumSearchMessageOverflow();
  },
  componentDidUpdate: function componentDidUpdate() {
    this.computeMinimumSearchMessageOverflow();
  },
  computeMinimumSearchMessageOverflow: function computeMinimumSearchMessageOverflow() {
    // Determine whether there's enough space to show the minimum search message inline (#2869)
    if (!this._wrapperEl || !this._iconEl || !this._inputEl || !this._helpTextEl) {
      return;
    }
    var wrapperWidth = this._wrapperEl.offsetWidth - this._iconEl.offsetWidth;
    var searchMessageWidth = this._helpTextEl.offsetWidth;
    var textWidth = (0, _MeasureText.getTextWidth)(this._inputEl);
    var minimumSearchMessageOverflows = searchMessageWidth > wrapperWidth - textWidth;
    if (minimumSearchMessageOverflows !== this.state.minimumSearchMessageOverflows) {
      this.setState({
        minimumSearchMessageOverflows: minimumSearchMessageOverflows
      });
    }
  },
  handleKeyDown: function handleKeyDown(evt) {
    var onKeyDown = this.props.onKeyDown;

    if (evt.key === 'Escape') {
      this.triggerClear();
    }
    (0, _Functions.callIfPossible)(onKeyDown, evt);
  },
  triggerClear: function triggerClear() {
    var onChange = this.props.onChange;

    onChange((0, _SyntheticEvent2.default)(''));
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        className = _props.className,
        clearable = _props.clearable,
        fieldsetContext = _props.fieldsetContext,
        icon = _props.icon,
        minimumSearchCount = _props.minimumSearchCount,
        placeholder = _props.placeholder,
        size = _props.size,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['className', 'clearable', 'fieldsetContext', 'icon', 'minimumSearchCount', 'placeholder', 'size', 'value']);

    var minimumSearchMessageOverflows = this.state.minimumSearchMessageOverflows;


    var computedClassName = (0, _reactUtils.classNames)('private-search-control', { 'private-search-control--xl': size === 'extra-large' }, className);

    var showClearButton = clearable && value;

    var minimumSearchMessage = getMinimumSearchMessage(minimumSearchCount, value);

    var renderedMinimumSearchMessage = minimumSearchMessage ? _react2.default.createElement(
      'span',
      {
        'aria-atomic': false,
        'aria-live': 'polite',
        className: (0, _reactUtils.classNames)('private-search-control__help-text', {
          'private-search-control__help-text--hidden': minimumSearchMessageOverflows
        }),
        ref: function ref(_ref) {
          _this._helpTextEl = _ref;
        }
      },
      minimumSearchMessage
    ) : null;

    var renderedSearchIcon = icon ? _react2.default.createElement(_UIIcon2.default, {
      className: (0, _reactUtils.classNames)('private-search-control__icon', {
        'private-search-control__icon--small': fieldsetContext.size === 'small',
        'private-search-control__icon--hidden': showClearButton
      }),
      name: 'search',
      ref: function ref(_ref2) {
        _this._iconEl = (0, _reactDom.findDOMNode)(_ref2);
      }
    }) : null;

    var renderedClearButton = showClearButton ? _react2.default.createElement(
      _UIClickable2.default,
      {
        className: 'private-search-control__clear-button',
        onClick: this.triggerClear,
        tabIndex: -1
      },
      _react2.default.createElement(_UIIcon2.default, { name: 'remove' })
    ) : null;

    return _react2.default.createElement(
      _UITooltip2.default,
      {
        open: minimumSearchMessage && minimumSearchMessageOverflows,
        title: minimumSearchMessage
      },
      _react2.default.createElement(
        'div',
        {
          className: computedClassName,
          ref: function ref(_ref3) {
            _this._wrapperEl = _ref3;
          }
        },
        _react2.default.createElement(_UITextInput2.default, _extends({}, rest, {
          className: 'private-search-control__input',
          onKeyDown: this.handleKeyDown,
          placeholder: (0, _lazyEval2.default)(placeholder),
          value: value
        })),
        _react2.default.createElement(
          'span',
          { className: 'private-search-control__foreground' },
          renderedMinimumSearchMessage,
          renderedSearchIcon
        ),
        renderedClearButton
      )
    );
  }
});

exports.default = (0, _ShareInput2.default)((0, _FieldsetContext.ConsumesFieldsetContext)((0, _Controllable2.default)((0, _IMESafe2.default)(UISearchInput))));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/input/UISearchInput.js
// module id = 162
// module chunks = 0